import { useOnboardingStore } from '@/store/onboardingStore';
import { ChipGroup } from '../components/ChipGroup';
import type { MatIdentity } from '@/types/onboarding';

const IDENTITY_OPTIONS: { value: MatIdentity; label: string; icon: string }[] = [
    { value: 'relentless_shooter', label: 'Relentless Shooter', icon: '⚡' },
    { value: 'defensive_counter', label: 'Defensive Counter', icon: '🛡️' },
    { value: 'upper_body', label: 'Upper Body / Thrower', icon: '🦍' },
    { value: 'grinder', label: 'Grinder', icon: '🔋' },
    { value: 'scrambler', label: 'Scrambler', icon: '🌀' },
    { value: 'technician', label: 'Technician', icon: '🧠' },
];

export function MatIdentityScreen() {
    const { profile, setMatIdentity, nextStep } = useOnboardingStore();

    const handleSelect = (val: string | string[]) => {
        const selected = Array.isArray(val) ? val[0] : val;
        setMatIdentity(selected as MatIdentity);
        setTimeout(nextStep, 300);
    };

    return (
        <div className="px-2 animate-fade-in-right">
            <h2 className="text-xl font-bold text-text-primary mb-2">
                What's your Mat Identity?
            </h2>
            <p className="text-text-secondary text-sm mb-6">
                How do you typically win matches?
            </p>

            <ChipGroup
                options={IDENTITY_OPTIONS}
                selected={profile.matIdentity || ''}
                onChange={handleSelect}
                columns={2}
            />
        </div>
    );
}
